import type { ComponentType, SVGProps } from 'react';
import { InstagramIcon } from '@/components/icons/InstagramIcon';
import { TikTokIcon } from '@/components/icons/TikTokIcon';
import { XIcon } from '@/components/icons/XIcon';

/**
 * 企画苔の公式SNSアカウント — SSOT
 *
 * フッターのアイコンリンクなど、SNSへの導線はここを参照する。
 * `label` はスクリーンリーダー向けの名前（アイコンのみのリンクなので aria-label に使う）。
 */
export interface SocialLink {
  /** サービス名（表示・aria-label の組み立てに使う） */
  name: string;
  /** アカウントのURL */
  url: string;
  /** スクリーンリーダー向けのリンク名 */
  label: string;
  /** ブランドアイコン */
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const SOCIAL_LINKS: SocialLink[] = [
  {
    name: 'X',
    url: 'https://x.com/kikakugoke',
    label: '企画苔の公式X（旧Twitter）',
    Icon: XIcon,
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/kikakugoke',
    label: '企画苔の公式Instagram',
    Icon: InstagramIcon,
  },
  {
    name: 'TikTok',
    url: 'https://www.tiktok.com/@kikakugoke',
    label: '企画苔の公式TikTok',
    Icon: TikTokIcon,
  },
];
